import * as RoleUpdateActions from '../actions/update.actions';
import { MENU } from '../../constants';

const permissionList = MENU.map((menu) => ({
  displayName: menu.label,
  menuCode: menu.key,
  isChecked: false,
}));

const initialState = {
  id: '',
  data: {
    name: '',
    permissions: permissionList,
    isChangeCommentRequired: false,
  },
  loading: false,
  submitting: false,
  error: null,
  message: '',
};

const update = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RoleUpdateActions.GET_ROLE:
      return {
        ...state,
        loading: true,
      };
    case RoleUpdateActions.GET_ROLE_SUCCESS:
      return {
        ...state,
        id: payload.data.id,
        loading: false,
        data: {
          ...payload.data,
          name: payload.data?.roleName,
          permissions: payload.data?.permissions,
          isChangeCommentRequired: payload.data?.isChangeCommentRequired,
        },
      };
    case RoleUpdateActions.GET_ROLE_FAIL:
      return {
        ...state,
        loading: false,
        message: payload.message,
        error: payload.error,
      };
    case RoleUpdateActions.CHANGE_ROLE_UPDATE_FORM:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload.data,
        },
      };
    case RoleUpdateActions.UPDATE_ROLE:
      return {
        ...state,
        submitting: true,
      };
    case RoleUpdateActions.UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case RoleUpdateActions.UPDATE_ROLE_FAIL:
      return {
        ...state,
        submitting: false,
        error: payload.error,
        message: payload.message,
      };
    case RoleUpdateActions.CLEAR_UPDATE_FORM:
      return initialState;
    default: {
      return state;
    }
  }
};

export default update;
